import { Component, h, Prop, Element } from '@stencil/core';
/**
 * COMPNAME is for creating a container for two blocks of rich text: a question and an answer
 */
@Component({
  tag: 'aafp-q-and-a',
  shadow: false,
})
export class AafpQAndA {
  /**
   * For the heading above the question and answer
   */
  @Prop() heading: string;

  /**
   * For the text of the question
   */
  @Prop() question: string;

  /**
   * For the text of the answer
   */
  @Prop() answer: string;

  @Element() element: HTMLElement;

  render() {
    return (
      <div class="adl-a-and-a">
        {this.heading && <h2 class="adl-h2">{this.heading}</h2>}
        <div class="adl-q-and-a__block adl-q-and-a__block--q adl-space__sm__m-b-md" innerHTML={this.question} />
        <div class="adl-q-and-a__block adl-q-and-a__block--a adl-space__sm__m-b-md" innerHTML={this.answer} />
      </div>
    );
  }
}
